import React, { useState} from 'react';
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Label , Input } from 'reactstrap';

function Parameters_Modal() {
  const [modal_center, setmodal_center] = useState(false);
      function tog_center() {
          setmodal_center(!modal_center);
      }

  return (
    <div>
     <Button color="primary" onClick={() => tog_center()}>parameters</Button>
     {/* Vertically Centered */}
            <Modal
                isOpen={modal_center}
                toggle={() => {
                    tog_center();
                }}
                centered
            >
                <ModalHeader className="modal-title cust-work border-bottom pb-3"
                id="parametersmodal" toggle={() => {
                        tog_center();
                    }}
                >
                  <span className='prompt_title' style={{fontSize:'20px'}}>Parameters</span> 
                  </ModalHeader>

                <ModalBody className="text-center">
                  <div className='parameters'>
                    <Row>
                      <Col md={4}>
                        <Label htmlFor="basiInput" className="form-label">Parameter 1</Label>                                                    
                      </Col>
                      <Col md={8}>
                         <Input type="text" className="form-control" id="basiInput" />
                      </Col>
                      </Row>
                      <Row className='mt-3'>
                      <Col md={4}>
                        <Label htmlFor="basiInput" className="form-label">Parameter 2</Label>                                                    
                      </Col>
                      <Col md={8}>
                         <Input type="text" className="form-control" id="basiInput" />
                      </Col>
                      </Row>
                      <Row className='mt-3'>
                      <Col md={4}>
                        <Label htmlFor="basiInput" className="form-label">Parameter 3</Label>                                                    
                      </Col>
                      <Col md={8}>
                         <Input type="text" className="form-control" id="basiInput" />
                      </Col>
                      </Row>
                      <Row className='mt-3'>
                      <Col md={4}>
                        <Label htmlFor="basiInput" className="form-label">Parameter 4</Label>                                                    
                      </Col>
                      <Col md={8}>
                         <Input type="text" className="form-control" id="basiInput" />
                      </Col>
                      </Row>
                      <Row className='mt-3'>
                      <Col md={4}>
                        <Label htmlFor="basiInput" className="form-label">Parameter 5</Label>                                                    
                      </Col>
                      <Col md={8}>
                         <Input type="text" className="form-control" id="basiInput" />
                      </Col>
                    </Row>
                  </div>                    
                  <div className="mt-4">                        
                      <div className="hstack gap-2 justify-content-center">
                          <Button color="light" onClick={() => setmodal_center(false)}>Close</Button>
                          <Button color="secondary" onClick={() => setmodal_center(false)}>Next</Button>
                      </div>
                  </div>
                </ModalBody>
            </Modal>
    </div>
  )
}

export default Parameters_Modal